import { Timestamp, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqDataToUpdate } from "../types";

type Params = {
  faqData: FaqDataToUpdate;
  faqId: string;
  faqGroupId: string;
};

export const updateFaq = async ({
  faqData,
  faqId,
  faqGroupId,
}: Params): Promise<void> => {
  const collectionRef = collection(db, `faqGroups/${faqGroupId}/faqs`);
  await updateDoc(doc(collectionRef, faqId), {
    ...faqData,
    updatedAt: Timestamp.now(),
  });
};
